import { GlobalToken } from 'antd';
import styled from 'styled-components';

interface SensorsKPITabContainerProps {
  $isReadOnly?: boolean;
  $activeTab?: string;
}

export const SensorsKPITabContainer = styled.div<SensorsKPITabContainerProps>`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  ${({ $isReadOnly, $activeTab }) => ($isReadOnly || $activeTab === 'published') && 'pointer-events:none;'}
  width: 70%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SensorsKPICardContainer = styled.div<{ theme: { token: GlobalToken }; $isReadOnly?: boolean }>`
  width: 100%;
  overflow: hidden;

  background: ${({ theme: { token } }) => token.colorBgContainer};
  border-radius: ${({ theme: { token } }) => token.borderRadius}px;

  ${({ $isReadOnly }) =>
    $isReadOnly &&
    `
      pointer-events: none;
      opacity: 0.6;
    `}
  .card-title-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .card-title {
    margin: 0;
    color: ${({ theme: { token } }) => token.colorPrimary};
  }

  .card-fallback-count {
    margin-left: ${({ theme: { token } }) => token.marginMD}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
  }

  .section-title {
    color: ${({ theme: { token } }) => token.colorText};
    display: block;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  .section-row-title {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    display: block;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  .styled-select {
    flex: 1;
    width: 100%;
  }

  @media (min-width: 768px) {
    .styled-select {
      width: 100%;
    }
  }

  .sensor-container {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .delete-button {
    flex-shrink: 0;
    margin-left: ${({ theme: { token } }) => token.marginXS}px;
    background: transparent;
    border: none;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    padding: 0;
    &:hover {
      background: transparent;
    }
  }

  .flow-icon {
    color: ${({ theme: { token } }) => token.colorPrimary};
    margin-right: ${({ theme: { token } }) => token.marginXS}px;
  }

  .sensor-section-content {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }

  .sensor-section-content-item {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }

  .space-vertical {
    width: 100%;
  }

  .flex-wrap {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    width: 100%;
  }

  .flex-1 {
    flex: 1;
    min-width: 200px;
  }

  .flex-2 {
    flex: 2;
    min-width: 200px;
  }

  .divider {
    margin: ${({ theme: { token } }) => token.marginLG}px 0;
  }
`;

export const KPISensorRowContainer = styled.div<{ $isReadOnly?: boolean }>`
  ${({ $isReadOnly }) => $isReadOnly && 'pointer-events: none; opacity: 0.6;'}

  .sensor-section {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    }
`;